import ApiClient from '@/services/apiClient';

export default class EventType {
    id;
    label;

    constructor(id, label) {
        this.id = id;
        this.label = label;
    }

    static constructFromObject(data, obj) {
        obj = obj || new EventType();
        if (data) {
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.label = ApiClient.convertToType(data['label'], 'String');
        }
        return obj;
    }

    toString() {
        return this.label;
    }
}
